import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './useStyles'
import TopesTable from '../TableNavigable/TableNavigable'

export const BoxTopes = ({ appParameters = [] }) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.boxTopes}>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#4B4952',
            paddingLeft: 10,
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          Topes
        </Typography>
      </Grid>
      <TopesTable appParameters={appParameters} />
    </Grid>
  )
}
